import { ControlledTextInput } from '@components/ControlledTextInput';
import { Checkbox, InfoIcon, Tooltip } from '@gurupay/gp-ui-library';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface TemplateFromPaymentProps {
	disabled?: boolean;
}

const TemplateFromPayment = ({ disabled }: TemplateFromPaymentProps) => {
	const { control, clearErrors, setValue } = useFormContext();
	const { t } = useTranslation('', { keyPrefix: 'payments.templates' });
	const paymentDetails = useWatch({ control, name: 'payment_details' });
	const saveAsTemplate = useWatch({ control, name: 'save_as_template' });

	return (
		<div className="space-y-space-16">
			<div className="flex items-center">
				<Controller
					control={control}
					defaultValue={false}
					name="save_as_template"
					render={({ field }) => (
						<Checkbox
							checked={!!field.value}
							disabled={disabled}
							label={t('save')}
							onChange={(newValue) => {
								field.onChange(newValue);

								if (newValue) {
									setValue('template_name', paymentDetails?.trim(), {
										shouldValidate: true,
									});
								} else {
									setValue('template_name', '');
									clearErrors('template_name');
								}
							}}
						/>
					)}
				/>

				<Tooltip className="flex flex-col items-center" content={t('tooltip')}>
					<span className="cursor-pointer text-neutral-600 p-space-4" role="tooltip">
						<InfoIcon className="w-space-16 h-space-16" />
					</span>
				</Tooltip>
			</div>

			{saveAsTemplate && (
				<ControlledTextInput
					isDisabled={disabled}
					label={t('form.templateName')}
					name="template_name"
					rules={{
						validate: (value, formValues) =>
							!formValues.save_as_template || !!value?.trim() || t('form.required'),
					}}
				/>
			)}
		</div>
	);
};

export default TemplateFromPayment;
